module.exports = __webpack_public_path__ + "menu3.jpg?efcf11ba0d159ddfe3ee173d131e8a6d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu3.jpg
// module id = 556
// module chunks = 0